import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import NavigationBar from './../../components/navigationBar/NavigationBar';
import DownloadAppBar from './../../components/downloadAppBar/DownloadAppBar';
import TitleBar from './../../components/titleBar/TitleBar';
import { injectIntl, FormattedMessage } from 'react-intl';
import DetailsSection from './../../components/detailsSection/DetailsSection';

import styles from './PlaceDetailsScreen.module.css';

import PhoneIcon from './../../assets/img/phone-icon.svg';
import ClockIcon from './../../assets/img/clock-icon.svg';
import MarkerIcon from './../../assets/img/marker-icon.svg';
import EarphoneIcon from './../../assets/img/earphone-icon.svg';
import PlaceResources from './../../resourcers/placeResources';

const places_not_avaliable_on_maps = [2, 11, 19];

class PlaceDetailsScreen extends Component {

    placeResources = new PlaceResources();

    constructor(props){
        super(props);
        this.intl = this.props.intl;
        this.componentDidMounted = false;
        this.navBarRef = React.createRef();
        this.titleBarRef = React.createRef();
        this.state = {
            isBack: false,
            readMore: false,
            pageTransitionEnd: false,
            place: false
        }

        window.scrollTo(0, 0);

        this.backTo = this.backTo.bind(this);
        this.getPlace = this.getPlace.bind(this);
        this.manageBack = this.manageBack.bind(this);
        this.animationEnd = this.animationEnd.bind(this);
        this.renderMorePlaces = this.renderMorePlaces.bind(this);
        this.renderAudioGuide = this.renderAudioGuide.bind(this);
        this.goToReadMore = this.goToReadMore.bind(this);
        this.goToAnotherPlace = this.goToAnotherPlace.bind(this);
        this.goToPlaceDetails = this.goToPlaceDetails.bind(this);
    }

    componentDidMount(props){
        window.addEventListener('popstate', this.manageBack);

        window.onscroll = function(){
            if(this.navBarRef.current){
                this.navBarRef.current.showHide(window.pageYOffset);
            }
            if(this.titleBarRef.current){
                this.titleBarRef.current.showHide(window.pageYOffset);
            }
        }.bind(this);
    }

    componentWillMount(props){
        this.getPlace();
    }

    getPlace(){
        this.placeResources.getPlace(this.props.placeID).then(place => {
            this.setState({
                place: place
            })
        })
    }

    componentWillUnmount(){
        window.removeEventListener('popstate', this.manageBack);
    }

    manageBack(evt){
        let pathname = evt.target.location.pathname;
        if(!pathname.includes("home") || !pathname.includes("events")){
            if(this.titleBarRef.current){
                this.titleBarRef.current.resetGallery();
            }
            window.scrollTo(0,0);
            this.setState({
                isBack: true,
                pageTransitionEnd: false
            });
            if(this.navBarRef.current){
                this.navBarRef.current.hide();
            }
        }
    }

    goToPlaceDetails(placeName) {
        let url = '/placeDetails/';
        if(this.props.shared){
            url = '/shared/placeDetails/';
        }

        this.setState({
            isBack: false,
            pageTransitionEnd: false
        });
        this.props.history.push({
            pathname: url + placeName,
            state: {
                animation: "slideInRight"
            }
        });
    }

    goToReadMore() {
        this.setState({
            readMore: !this.state.readMore
        });
        // this.setState({
        //     isBack: false
        // }, () => this.props.history.push({
        //     pathname: '/readPlaceDetails/' + this.props.place.name,
        //     state: {
        //         animation: ""
        //     }
        // }));
    }

    goToAnotherPlace(place) {
        if(this.titleBarRef.current){
            this.titleBarRef.current.resetGallery();
        }
        window.scrollTo(0,0);
        if(this.navBarRef.current){
            this.navBarRef.current.hide();
        }
        this.goToPlaceDetails(place.id);
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    backTo(){
        this.props.history.goBack();
    }

    formatDuration(duration) {
        var hours   = Math.floor(duration / 3600);
        var minutes = Math.floor((duration - (hours * 3600)) / 60);
        var seconds = duration - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return minutes + ':' + seconds;
    }

    renderMorePlaces() {
        if(this.props.place && this.props.place.more_places) {
            let list = this.props.getMorePlaces(this.props.place.more_places);

            let places = list.map((place, i) => {
                return (
                    <div key={i} className={styles.placeCard} onClick={() => this.goToAnotherPlace(place)}>
                        <img src={place.imgs[0].replace("images", "images/275x262")} className={styles.placeCardImage} />
                        <h6>{place.name}</h6>
                    </div>
                );
            });
            return (
                <div className={styles.horizontalContainer}>
                    {places}
                </div>
            );
        }
    }

    renderAudioGuide() {
        if(this.props.place && this.props.place.audio_guide) {
            let audios = this.props.place.audio_guide.map((audio, i) => {
                return (
                    <div className={styles.audioCard} key={i}>
                        <ReactSVG src={EarphoneIcon} />
                        <h1>{audio.title}</h1>
                        <h2>{this.formatDuration(audio.duration)}</h2>
                    </div>
                );
            });
            return (
                <div className={styles.horizontalContainer}>
                    {audios}
                </div>
            );
        }
    }

    render(){
        let backTo, navigationBar, descriptionContainer, linkText, animation, phone, time, location, mapAddress = "";

        if(this.props.shared){
            if (this.props.shared && this.state.place) {
                let query;
                if (!places_not_avaliable_on_maps.includes(parseInt(this.state.place.item_id))) {
                    query = this.state.place.title;
                } else {
                    query = this.state.place.extra.address.latitude + "," + this.state.place.extra.address.longitude;
                }

                if ((navigator.platform.indexOf("iPhone") != -1) ||
                    (navigator.platform.indexOf("iPad") != -1) ||
                    (navigator.platform.indexOf("iPod") != -1)) {
                    mapAddress = "https://maps.google.com/maps?center=";
                    mapAddress += this.state.place.extra.address.latitude + "," + this.state.place.extra.address.longitude;
                    mapAddress += "&q=" + query;
                } else {
                    mapAddress = "geo:" + this.state.place.extra.address.latitude + "," + this.state.place.extra.address.longitude;
                    mapAddress += "?q=" + query;
                }
            }

            // let experiencesText = this.intl.formatMessage({ id: "experiencesText" });

            if (!this.state.pageTransitionEnd && this.props.location.state && this.props.location.state.animation) {
                if (this.state.isBack) {
                    animation = "animated slideInLeft";
                } else {
                    animation = "animated " + this.props.location.state.animation;
                }
            }

            if (this.props.place && this.props.place !== "NOT_FOUND") {
                linkText = "";
                descriptionContainer = styles.descriptionContainerWithoutOpen;

                if (this.state.place && this.state.place.extra.telephone) {
                    let phoneLink = "tel:" + this.state.place.extra.telephone;
                    phone = (
                        <a href={phoneLink} className={styles.phoneLink}>
                            <p className={styles.infoContainer}>
                                <ReactSVG src={PhoneIcon} /> {this.state.place.extra.telephone}
                            </p>
                        </a>
                    );
                }

                if (this.state.place && this.state.place.opening_hours) {
                    time = (
                        <p className={styles.infoContainer}>
                            <ReactSVG src={ClockIcon} /> {this.state.place.opening_hours}
                        </p>
                    );
                }

                if (this.state.place && this.state.place.extra.address) {
                    let address = this.state.place.address;
                    location = (
                        <p className={styles.infoContainer}>
                            <ReactSVG src={MarkerIcon} />
                            <div>
                                <span className={styles.textLink} onClick={() => window.open(mapAddress, "_self")}>
                                    <FormattedMessage id="howToArrive" />
                                </span>
                                <br />
                                <span className={styles.addressText}>
                                    {`${address.street_name}, ${address.addr_number}, ${address.district}. ${address.city} - ${address.state}`}
                                </span>
                            </div>
                        </p>
                    );
                }
            }

            navigationBar = (
                <DownloadAppBar />
            );

            return (
                <TitleBar ref={this.titleBarRef}
                    className={animation}
                    onAnimationEnd={this.animationEnd}
                    backTo={backTo}
                    images={this.state.place && this.state.place.extra.images ? this.state.place.extra.images : []}
                    title={this.state.place && this.state.place.title ? this.state.place.title : ''}>
                    <DetailsSection>
                        <div className={descriptionContainer}>
                            <p>
                                {this.state.place && this.state.place.description ? this.state.place.description.trim() : ''}
                            </p>
                        </div>
                        <p></p>
                        <p onClick={this.goToReadMore} className={[styles.textLink, styles.readMore].join(' ')}>
                            <b>{linkText}</b>
                        </p>
                        {phone}
                        {time}
                        {location}
                    </DetailsSection>
                    {/* <DetailsSection title="Áudio Guia">
                    {this.renderAudioGuide()}
                </DetailsSection> */}
                    {/* <DetailsSection title={experiencesText}>
                        {this.renderMorePlaces()}
                    </DetailsSection> */}
                    <div className={styles.navigationBarContainer}>
                        {navigationBar}
                    </div>
                </TitleBar>
            );
        } else if (!this.props.shared){
            if (this.props.place && this.props.place.location) {
                let query;
                if (!places_not_avaliable_on_maps.includes(parseInt(this.props.place.id))) {
                    query = this.props.place.name;
                } else {
                    if (parseInt(this.props.place.id) === 11) {
                        query = this.props.place.name.replace("Municipal", "Mun.");
                    } else {
                        query = this.props.place.location.lat + "," + this.props.place.location.lng;
                    }
                }

                if ((navigator.platform.indexOf("iPhone") != -1) ||
                    (navigator.platform.indexOf("iPad") != -1) ||
                    (navigator.platform.indexOf("iPod") != -1)) {
                    mapAddress = "https://maps.google.com/maps?center=";
                    mapAddress += this.props.place.location.lat + "," + this.props.place.location.lng;
                    mapAddress += "&q=" + query;
                } else {
                    mapAddress = "geo:" + this.props.place.location.lat + "," + this.props.place.location.lng;
                    mapAddress += "?q=" + query;
                }
            }

            let experiencesText = this.intl.formatMessage({ id: "experiencesText" });

            if (!this.state.pageTransitionEnd && this.props.location.state && this.props.location.state.animation) {
                if (this.state.isBack) {
                    animation = "animated slideInLeft";
                } else {
                    animation = "animated " + this.props.location.state.animation;
                }
            }

            if (this.props.place && this.props.place !== "NOT_FOUND") {
                linkText = "";
                descriptionContainer = styles.descriptionContainerWithoutOpen;
                if (this.props.place.phone_number !== "") {
                    let phoneLink = "tel:" + this.props.place.phone_number;
                    phone = (
                        <a href={phoneLink} className={styles.phoneLink}>
                            <p className={styles.infoContainer}>
                                <ReactSVG src={PhoneIcon} /> {this.props.place ? this.props.place.phone_number : ''}
                            </p>
                        </a>
                    );
                }

                if (this.props.place.opening_hours !== "") {
                    time = (
                        <p className={styles.infoContainer}>
                            <ReactSVG src={ClockIcon} /> {(this.props.place && this.props.place.opening_hours) ? this.props.place.opening_hours : ''}
                        </p>
                    );
                }

                if (this.props.place.address) {
                    location = (
                        <p className={styles.infoContainer}>
                            <ReactSVG src={MarkerIcon} />
                            <div>
                                <span className={styles.textLink} onClick={() => window.open(mapAddress, "_self")}>
                                    <FormattedMessage id="howToArrive" />
                                </span>
                                <br />
                                <span className={styles.addressText}>
                                    {this.props.place ? this.props.place.address : ''}
                                </span>
                            </div>
                        </p>
                    );
                }
            }

            if (!this.props.shared) {
                backTo = this.backTo;
                navigationBar = (
                    <NavigationBar history={this.props.history} ref={this.navBarRef} active={"explore"} />
                );
            } else {
                navigationBar = (
                    <DownloadAppBar />
                );
            }

            return (
                <TitleBar ref={this.titleBarRef}
                    className={animation}
                    onAnimationEnd={this.animationEnd}
                    backTo={backTo}
                    images={this.props.place.imgs ? this.props.place.imgs : []}
                    title={this.props.place.name ? this.props.place.name : ''}>
                    <DetailsSection>
                        <div className={descriptionContainer}>
                            <p>
                                {this.props.place.desc ? this.props.place.desc.trim() : ''}
                            </p>
                        </div>
                        <p></p>
                        <p onClick={this.goToReadMore} className={[styles.textLink, styles.readMore].join(' ')}>
                            <b>{linkText}</b>
                        </p>
                        {phone}
                        {time}
                        {location}
                    </DetailsSection>
                    {/* <DetailsSection title="Áudio Guia">
                {this.renderAudioGuide()}
            </DetailsSection> */}
                    <DetailsSection title={experiencesText}>
                        {this.renderMorePlaces()}
                    </DetailsSection>
                    <div className={styles.navigationBarContainer}>
                        {navigationBar}
                    </div>
                </TitleBar>
            );
        }
    }
}

export default injectIntl(PlaceDetailsScreen);